import $ from 'jquery';

const CONFIGURATION_NAME_REGEXP = /^configurations\[([^\]]+)\]\[[^\]]+\]$/;

let isInternalSelectSync = false;

const parseProductTypeId = (name) => {
    const match = CONFIGURATION_NAME_REGEXP.exec(name || '');

    return match ? match[1] : null;
};

const hasSelect2 = (select) => {
    return Boolean($.fn?.select2 && $(select).data('select2'));
};

const syncSelectUi = (select) => {
    if (!hasSelect2(select)) {
        return;
    }

    isInternalSelectSync = true;

    try {
        $(select).trigger('change.select2');
    } finally {
        isInternalSelectSync = false;
    }
};

const resetSelectToEmptyValue = (select) => {
    if (select.value === '') {
        return false;
    }

    select.value = '';

    if (select.value === '') {
        return true;
    }

    const emptyOption = Array.from(select.options).find((option) => option.value === '');

    if (emptyOption) {
        emptyOption.selected = true;
        return true;
    }

    return false;
};

const resolveInitialConflicts = (selects) => {
    const seenValues = new Set();
    let hasSelectionChanges = false;

    selects.forEach((select) => {
        const value = select.value || '';

        if (value === '') {
            return;
        }

        if (seenValues.has(value)) {
            hasSelectionChanges = resetSelectToEmptyValue(select) || hasSelectionChanges;
            return;
        }

        seenValues.add(value);
    });

    return hasSelectionChanges;
};

const collectGroupState = (selects) => {
    const selectedValues = new Map();
    const busyValues = new Set();

    selects.forEach((select) => {
        const value = select.value || '';

        selectedValues.set(select, value);

        if (value !== '') {
            busyValues.add(value);
        }
    });

    return {
        selectedValues,
        busyValues,
    };
};

const applyDisabledOptions = (selects) => {
    const { selectedValues, busyValues } = collectGroupState(selects);
    let hasChanges = false;

    selects.forEach((select) => {
        const currentValue = selectedValues.get(select) || '';

        Array.from(select.options).forEach((option) => {
            const optionValue = option.value || '';
            const shouldDisable = optionValue !== '' && optionValue !== currentValue && busyValues.has(optionValue);

            if (option.disabled !== shouldDisable) {
                option.disabled = shouldDisable;
                hasChanges = true;
            }
        });
    });

    return hasChanges;
};

const refreshGroup = (selects, options = {}) => {
    const { resolveConflicts = false } = options;
    const hasSelectionChanges = resolveConflicts ? resolveInitialConflicts(selects) : false;
    const hasDisabledChanges = applyDisabledOptions(selects);

    if (!hasSelectionChanges && !hasDisabledChanges) {
        return;
    }

    selects.forEach((select) => {
        syncSelectUi(select);
    });
};

const buildGroups = () => {
    const groupedSelects = new Map();
    const configurationSelects = document.querySelectorAll('tr.supplier-configuration select[name^="configurations["]');

    configurationSelects.forEach((select) => {
        const productTypeId = parseProductTypeId(select.name);

        if (!productTypeId) {
            return;
        }

        if (!groupedSelects.has(productTypeId)) {
            groupedSelects.set(productTypeId, []);
        }

        groupedSelects.get(productTypeId).push(select);
    });

    return groupedSelects;
};

const initConfiguratorSmartSelects = () => {
    const groups = buildGroups();

    if (groups.size === 0) {
        return;
    }

    groups.forEach((selects) => {
        refreshGroup(selects, { resolveConflicts: true });
    });

    groups.forEach((selects, productTypeId) => {
        selects.forEach((select) => {
            select.addEventListener('change', () => {
                if (isInternalSelectSync) {
                    return;
                }

                refreshGroup(groups.get(productTypeId) || []);
            });
        });
    });
};

initConfiguratorSmartSelects();
